module.exports = __webpack_public_path__ + "static/media/left_banner.b10904bf.svg";